import { notifications, coupons } from '@/data/content';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '@/components/ui/card';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { SEO } from '@/components/SEO';
import { IconBell } from '@tabler/icons-react';

const Notifications = () => {
  return (
    <div className="min-h-screen bg-background py-12">
      <SEO
        title="Notifications"
        description="Stay updated with the latest deals, promotions, and store news. Manage your notification preferences."
      />
      <div className="max-w-7xl mx-auto px-4">
        <div className="flex items-center justify-between mb-8">
          <h1 className="text-4xl font-bold text-foreground">Notifications & Coupons</h1>
          <Badge variant="secondary">
            <IconBell className="h-3 w-3 mr-1" />
            Stay Updated
          </Badge>
        </div>

        {/* Notification Preferences */}
        <div className="mb-12">
          <h2 className="text-2xl font-bold text-foreground mb-6">Notification Preferences</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
            {notifications.map((notification, index) => (
              <Card key={index} className="hover:shadow-lg transition-shadow">
                <CardHeader>
                  <CardTitle className="text-xl">{notification.title}</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <CardDescription className="text-muted-foreground">
                    {notification.desc}
                  </CardDescription>
                  <Button className="w-full">Enable Notifications</Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>

        {/* Digital Coupons */}
        <div>
          <h2 className="text-2xl font-bold text-foreground mb-6">Digital Coupons</h2>
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {coupons.map((coupon) => (
              <Card key={coupon.id} className="hover:shadow-lg transition-shadow">
                <CardHeader>
                  <CardTitle className="text-lg">{coupon.title}</CardTitle>
                </CardHeader>
                <CardContent className="space-y-4">
                  <CardDescription className="text-muted-foreground text-sm">
                    {coupon.description}
                  </CardDescription>
                  <Badge variant="outline" className="w-fit">
                    {coupon.expires}
                  </Badge>
                  <Button className="w-full">Clip Coupon</Button>
                </CardContent>
              </Card>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Notifications;
